import React from 'react';

const Header = () => {
    return (
        <header>
            <h1>Timer Tasks</h1>
        </header>
    );
}
 
export default Header;